'use client';

import { InstagramEmbed } from 'react-social-media-embed';

import { EmbedInstagram as TEmbedInstagram } from '~/server/generated/contentful-graphql';

export function EmbedInstagram({ entry }: { entry: TEmbedInstagram }) {
  if (!entry.url) return null;

  return <InstagramEmbed url={entry.url} width={320} />;
}
